export default {
  // Stat cards
  todayAlertCount: 'Today Alerts',
  scanCountAlert: 'Scan Count Alerts',
  crossRegionAlert: 'Cross-Region Alerts',
  vsYesterday: 'vs Yesterday',
  // Search
  qrcode: 'QR Code',
  qrcodePlaceholder: 'Enter QR code number',
  alertTime: 'Alert Time',
  startTime: 'Start Time',
  endTime: 'End Time',
  alertType: 'Alert Type',
  alertTypePlaceholder: 'Please select',
  alertStatus: 'Alert Status',
  alertStatusPlaceholder: 'Please select',
  // Alert types
  typeScanCount: 'Scan Count',
  typeCrossRegion: 'Cross-Region',
  // Alert statuses
  statusAlerting: 'Alerting',
  statusResolved: 'Resolved',
  statusDisabled: 'Disabled',
  // Actions
  export: 'Export',
  // Table columns
  colQrcode: 'QR Code',
  colUserInfo: 'User Info',
  colProductInfo: 'Product Info',
  colAlertRule: 'Alert Rule',
  colAlertStatus: 'Status',
  colAlertTime: 'Alert Time',
  colAction: 'Action',
  // Actions column
  resolveAlert: 'Resolve',
  disableQrcode: 'Disable QR Code',
  // Resolve modal
  resolveTitle: 'Resolve Alert',
  resolveContent: 'Are you sure to resolve this alert?',
  resolveRemark: 'Remark',
  resolveRemarkPlaceholder: 'Enter remark (optional)',
  // Disable modal
  disableTitle: 'Disable QR Code',
  disableContent: 'Are you sure to disable this QR code? It will be invalid for scanning.',
  disableReason: 'Disable Reason',
  disableReasonPlaceholder: 'Enter disable reason',
  disableReasonRequired: 'Please enter disable reason',
  // Empty state
  emptyText: 'No alert records',
};
